import axios from "axios";

const dropdownResults = document.querySelector('.search-wrapper');
const pageResults = document.querySelector('.search-wrapper_results-page');

class InitResults {
    init() {
        new Results(dropdownResults, '/search-results');
        new Results(pageResults, '/search-results', true);
    }
}





class Results {
    constructor(container, path, disabled = false) {
        this.container = container;
        this.path = path;
        this.isSubmitDisabled = disabled;

        if (this.container) {
            this.input = this.container.querySelector('input[type="search"]');
            this.resultsContainer = document.querySelector('#searchResults');

            this.init();
        }
    }

    init() {
        this.inputHandler();
        this.clickHandler();
        this.keysHandler();

        if (this.isSubmitDisabled) {
            this.disableSubmit();
        }
    }

    inputHandler() {
        let timer;

        this.input.addEventListener('input', (e) => {
            const value = e.target.value;

            this.toggle(value);

            clearTimeout(timer);
            timer = setTimeout(() => this.request(value), 300);
        });
    }

    clickHandler() {
        document.body.addEventListener('click', (e) => {
            if (e.target.closest('.search-form') && this.input.value != '') {
                this.showResults();
            } else {
                this.hideResults();
            }
        })
    }

    keysHandler() {
        document.addEventListener('keydown', (e) => {
            if (document.activeElement === this.input && ['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) {
                const items = [this.input, ...Array.from(this.resultsContainer.querySelectorAll('#searchResults.results-container li, #searchResults.results-container > a'))];
                let currentIndex = items.findIndex((item) => item.classList.contains('highlight'));
                currentIndex = currentIndex === -1 ? 0 : currentIndex;
                const current = items[currentIndex];

                if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                    e.preventDefault();
                    let nextIndex = currentIndex + (e.key === 'ArrowDown' ? 1 : -1);
                    nextIndex = nextIndex < 0 ? items.length -1 : nextIndex % items.length;
                    const next = items[nextIndex];
                    current?.classList.remove('highlight');
                    next?.classList.add('highlight');
                } else if (e.key === 'Enter' && current) {
                    e.preventDefault();
                    if (current.tagName === 'A') {
                        current.click();
                    } else if (current.tagName === 'INPUT') {
                        current.parentElement.submit();
                    } else {
                        current.querySelector('a')?.click();
                    }
                }
            }
        });
    }

    disableSubmit() {
        const from = this.input.parentNode;

        from.addEventListener('submit', (e) => e.preventDefault())
    }

    request(value) {
        const path = `${this.path}?q=${value}`

        const options = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        axios.post(path, options)
            .then(response => {
                this.resultsContainer.innerHTML = '';
                this.insertResults(response.data)
            })
    }

    insertResults(results) {
        this.resultsContainer.innerHTML = results;
    }

    results(results) {
        results.forEach(result => {
            console.log(result.title);
        })
    }

    toggle(value) {
        if (value) {
            this.showResults();
        } else {
            this.hideResults();
        }
    }

    showResults() {
        if (this.resultsContainer.getAttribute('class')) {
            this.resultsContainer.classList.remove('hidden');
        }
    }

    hideResults() {
        if (this.resultsContainer.getAttribute('class')) {
            this.resultsContainer.classList.add('hidden');
        }
    }
}

export default new InitResults();


